import React from 'react'
import TextField from '@material-ui/core/TextField'

const Input = props => <TextField style={{ width: '100%' }} {...props} />

export default Input
